import { gql } from '@src/lib/gql'

export const RESET_ADVISOR_STRIPE_CONNECT = gql`
  mutation ResetAdvisorStripeConnect {
    resetAdvisorStripeConnect {
      stripeConnectAccountId
      stripeConnectStatusKey
    }
  }
`
